import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegbpService } from '../api/src/app/services/regbp.service';
import { map, concatAll, toArray } from 'rxjs/operators';
import { KeyValue } from '@angular/common';
import { Cacheable } from 'ngx-cacheable';
import { SiteDetail } from '..';
import { Site } from '../api/src/app/models/REGBP-V1.0.0/site.model';

@Injectable({
  providedIn: 'root'
})
export class SitesFacade {
  constructor(public regbpService: RegbpService) {}

  @Cacheable({ maxCacheCount: 3 })
  getSites(language: string): Observable<KeyValue<string, SiteDetail>[]> {
    return this.regbpService.getSites(language).pipe(
      map((results: any) => results.$response.body.values),
      concatAll(),
      map((siteObject: Site) => {
        return {
          key: siteObject.siteListID,
          value: siteObject.traductions[language]
        };
      }),
      toArray()
    );
  }
}
